<template>
	<v-menu
		open-on-hover
		offset-y
		:top="top"
		:left="left"
		:right="right"
		:min-width="minWidth"
		:bottom="bottom"
		:close-delay="hoverable ? 200 : 0"
		content-class="rmp-information-menu"
		:nudge-top="bottom ? undefined : nudge"
		:nudge-bottom="bottom ? nudge : undefined">
		<template v-slot:activator="{ on, attrs }">
			<v-icon
				:color="iconColor"
				v-bind="attrs"
				:class="{ 'mb-1': offsetBottom }"
				v-on="on"
				style="height: 16px;"
				size="20"
				@mouseover="isHovered = true"
				@mouseleave="isHovered = false">
				mdi-information-outline
			</v-icon>
		</template>
		<slot>
			<rmp-text type="caption-small" class="grey--text text--darken-4 text-pre-line">{{ text }}</rmp-text>
		</slot>
	</v-menu>
</template>

<script setup lang="ts">
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import { useColors } from "@rmp/core/composables/useColors";
import { computed, ref } from "vue";

const { colors } = useColors();

interface RmpInformationMenuProps {
	top?: boolean;
	left?: boolean;
	right?: boolean;
	bottom?: boolean;
	text?: string;
	minWidth?: number | string;
	offsetBottom?: boolean;
	nudge?: number | string;
	hoverable?: boolean;
}

const props = withDefaults(defineProps<RmpInformationMenuProps>(), {
	top: true,
	left: false,
	right: false,
	bottom: false,
	offsetBottom: false,
	nudge: 6,
	hoverable: false
});

const isHovered = ref<boolean>(false);

const iconColor = computed(() => {
	return !isHovered.value ? colors.primary.base : colors.secondary.base;
});
</script>
<style scoped lang="scss">
.rmp-information-menu {
	line-height: 10px !important;
	
	&.v-menu__content {
		background: var(--v-white-base) !important;
		box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
		max-width: 235px;
		border-radius: 8px;
		padding: 8px;
	}
}
</style>
